import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Institution} from "../../../../../models/institution";
import {Registration} from "../../../../../models/registration";
import {Role} from "../../../../../models/role";
import {InstitutionControllerService} from "../../../../../services/institution-controller/institution-controller.service";
import {RegistrationInstitutionControllerService} from "../../../../../services/institution-controller/institution-registration-controller.service";
import {InstitutionService} from "../../../../../services/institution-controller/institution.service";
import {RoleInstitutionControllerService} from "../../../../../services/role-controller/role-institution-controller.service";
import {Store} from "../../../../../services/store.service";
import {UnitService} from "../../../../../services/unit-controller/unit.service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {RoleInstitution} from "../../../../../models/role-institution";
import {UnitRoleComponent} from "../unit/unit-role.component";

@Component({
    selector: "institution-role",
    templateUrl: "./institution-role.component.html",
    providers: [RoleInstitutionControllerService, InstitutionControllerService, RegistrationInstitutionControllerService],
    styles: [],
})
export class InstitutionRoleComponent extends TranslatedBaseError implements OnChanges, OnInit {

    @Input() public role: Role;
    @Input() public mandatory: boolean = false;
    @Input() public institutions: Institution[];
    @Input() public roleInstitutions: RoleInstitution[];
    @Output() public roleInstitutionsLength = new EventEmitter();

    @Output() public modalClosedEvent = new EventEmitter();
    public institution: Institution;
    public selectedInstitution: Institution;
    public roleId: string;
    public registration: Registration;
    public availableRoleInstitutions: any[];
    public selectedRoleInstitution: any[];

    public searchInstitutionFilter: any;

    public firstRequestDone: boolean = false;
    public addNew: boolean = false;
    public showDeterminantBuilder: boolean = false;
    public showList: boolean = false;

    constructor(private roleInstitutionControllerService: RoleInstitutionControllerService,
                private institutionControllerService: InstitutionControllerService,
                private institutionService: InstitutionService,
                private unitService: UnitService,
                public store: Store,
                toastr: ToastrService, public translateService: TranslateService, private route: ActivatedRoute) {
        super(toastr, translateService);
    }

    public ngOnInit() {
        this.route.params.subscribe((params) => {
            this.roleId = params.roleId;
        });
        this.updateData();
    }

    public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
      if (changes.roleInstitutions?.previousValue && !changes.roleInstitutions.firstChange) {
        this.getName();
      }
    }

    public getName() {
        if (this.institutions !== null && this.institutions !== undefined && this.roleInstitutions !== null) {
            for (const registr of this.roleInstitutions) {
              registr.institutionName = this.institutions.find((i) => {
                return i.id?.toString() === registr.institutionId?.toString();
              })?.name;
              console.log("getName loop", registr, this.institutions);
            }
            this.roleInstitutions.sort((a, b) => {
              return (a.institutionName > b.institutionName) ? 1 : ((b.institutionName > a.institutionName) ? -1 : 0);
            });
        }
        console.log("getName", this.roleInstitutions, this.institutions);
        this.pushValuesToDropdown();
    }

  public addRoleInstitution(institution: Institution[]) {
    console.log("addRoleInstitution", institution);
    const addedInstitution = institution[0];
    if (this.roleId) {
      // for visual effect

      this.roleInstitutionControllerService.createRoleInstitution(this.roleId, addedInstitution.id).subscribe(
          (createData) => {
            this.responseSuccessful("Institution added to Role!");
            this.showList = false;
            createData.institutionName = this.institutions.find((i) => i.id === createData.institutionId)?.name;
            this.roleInstitutions.push(createData);
            this.institutionControllerService.getInstitutionChildrenByRoleInstitution(createData).subscribe(
              (inst) => {
                UnitRoleComponent.addUnits(inst, createData);
              },
            );
            this.roleInstitutionsLength.emit({roleInstitutionsLength: this.roleInstitutions.length});
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
      );

    }
  }

    public updateData() {
        this.showList = false;
        this.unitService.updateData();
        this.getName();
    }

  public pushValuesToDropdown() {
    console.log("pushValuesToDropdown", this.roleInstitutions);
    const that = this;
    this.availableRoleInstitutions = [];
    this.selectedRoleInstitution = [];
    this.roleInstitutions?.forEach((roleInstitution) => {
      that.selectedRoleInstitution.push({id: roleInstitution.id, text: roleInstitution.institutionName});
    });
    if (this.institutions) {
      this.institutions.forEach((institution) => {
        that.availableRoleInstitutions.push({id: institution.id, text: institution.name});
      });
    }
  }

  public registrationInstitutionSelected(inst: Institution) {
    this.selectedInstitution = inst;
  }

  public deleteRoleInstitution(isConfirmed, roleInstitutionId, index) {
    if (isConfirmed) {
      this.roleInstitutionControllerService.deleteRoleInstitution(roleInstitutionId).subscribe(
          (data) => {
            this.roleInstitutions.splice(index, 1);
            this.roleInstitutionsLength.emit({roleInstitutionsLength: this.roleInstitutions.length});
          },
      );
    }
  }

  public selectRoleInstitution(value: any): void {
    if (this.roleId) {
      this.roleInstitutionControllerService.createRoleInstitution(this.roleId, value.id).subscribe(
        (data) => {this.responseSuccessful("Data is saved!"); },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
      );
    }
  }

  public openEdit(roleInstitution: any, name?: string) {
    if (roleInstitution) {
      this.institution = this.institutions.find((i) => {
        return String(i.id) === String(roleInstitution.institutionId);
      });
      this.addNew = false;
    } else {
      this.institution = new Institution();
      this.institution.name = name || this.searchInstitutionFilter?.name || "";
      this.addNew = true;
    }
    this.updateEditData();
  }

  public updateEditData() {
    this.showList = false;
    this.store.state.common.sections.type = "institution";
    this.institutionService.institution = JSON.parse(JSON.stringify(this.institution)); // mini-hack so the list doesn't update when working in edit layer
    this.institutionService.role = this.role;
    this.institutionService.roleInstitutions = this.roleInstitutions;
    this.institutionService.addNew = this.addNew;
    this.institutionService.initEdit();
  }

  public closeSection() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = undefined;
    }

    public searchInstitutionChanged(value: any): void {
        this.searchInstitutionFilter = { name: value };
    }
}
